import Link from 'gatsby-link';
import React, { Component } from 'react';
import { STATES } from '@upsolve/shared';
import { padStart, startCase } from 'lodash';

import Article from '../components/Layout/Article.div';
import AuthorsBlock from '../components/Layout/AuthorsBlock';
import BreadcrumbNav from '../components/Layout/BreadcrumbNav';
import CTASideBySideOfferings from '../components/CTA/CTASideBySideOfferings';
import ContentShareRow from '../components/Share/ContentShareRow';
import CTATestimonial from '../components/Programmatic/CTATestimonial';
import HeroFilerCta from '../components/CTA/HeroFilerCta';
import HorizontalRule from '../components/Layout/HorizontalRule.hr'
import MainFooter from '../components/Layout/Footer'
import MainHeader from '../components/Layout/Header'
import SCREENER_CTA_TYPES from '../components/analytics/screenerCtaTypes';
import SEO from '../components/SEO/SEO';
import SidebarAboutUs from '../components/Layout/SidebarAboutUs';
import SidebarCta from '../components/CTA/SidebarCta';
import StateCityGuidesLinks from '../components/Programmatic/StateCityGuidesLinks';
import TopLevelLayout from '../components/Layout/TopLevelLayout';
import UpsolveFilersCount from '../components/ProofBuilders/UpsolveFilersCount';
import getScreenerUrl from '../components/Links/getScreenerUrl';
import privatePricings from '../../content/privatePricings.json';
import trackPageView from '../components/analytics/trackPageView';
import { H1, H5 } from '../components/Type/Display.h';

import * as CONTENT_CREATION_METHODS from '../components/analytics/contentCreationMethods';
import * as CONTENT_GROUPS from '../components/analytics/contentGroups';
import * as CONTENT_TOPICS from '../components/analytics/contentTopics';
import * as SEARCH_TERM_TARGETS from '../components/analytics/searchTermTargets';

const contentGroup = CONTENT_GROUPS.CITY_PAGE;

export default class CityAttorneyPricingTemplate extends Component {
  componentDidMount() {
    trackPageView({
      contentCreationMethod: CONTENT_CREATION_METHODS.PROGRAMMATIC,
      contentGroup,
      contentTopics: [CONTENT_TOPICS.ATTORNEY_COST],
      contentLocalized: true,
      searchTermTarget: SEARCH_TERM_TARGETS.HOW_MUCH_DOES_A_BANKRUPTCY_ATTORNEY_COST,
    });
  }

  render() {
    const { path } = this.props;
    const { amp, city, created, modified, state } = this.props.pageContext;
    const title = `Cost of a Bankruptcy Attorney in ${startCase(city.city)}, ${city.state}${(city.zipcodes || []).length === 1 ? ` ${padStart(city.zipcodes[0], 5, '0')}`: ''}`;
    const description = `Bankruptcy attorneys in ${startCase(city.city)}, ${city.state} cost between $${Number(privatePricings[city.state].low).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} and $${Number(privatePricings[city.state].high).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}. Upsolve is a nonprofit giving free assistance for chapter 7 bankruptcies.`;
    const cta = `File Bankruptcy in ${startCase(city.city)}`;
    const screenerUrl = getScreenerUrl({ cta: SCREENER_CTA_TYPES.CITY_PAGE, contentGroup });

    return (
      <TopLevelLayout showPersistentCta persistentCtaText={cta}>
        <SEO
          seoNode={{
            title,
            description,
            structuredType: 'article',
            article: {
              createdAt: created,
              updatedAt: modified,
            },
          }}
        />
        <MainHeader contentGroup={contentGroup} />
        <Article>
          <BreadcrumbNav />
          <div className="article__body">
            <article className="article__content">
              <div className="content-hero">
                <header className="content-hero__header">
                  <H1>Bankruptcy attorneys in {startCase(city.city)}, {state}{(city.zipcodes || []).length === 1 ? ` ${padStart(city.zipcodes[0], 5, '0')}`: ''} cost between ${Number(privatePricings[city.state].low).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} &ndash; ${Number(privatePricings[city.state].high).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</H1>
                  <UpsolveFilersCount />
                  <HorizontalRule />
                  <AuthorsBlock
                    createdAt={created}
                    updatedAt={modified}
                  />
                </header>
              </div>
              <div className="content-body">
                <div className="content-body__container">
                  <section>
                    <p>
                      The price of a personal bankruptcy attorney in {STATES[city.state]} is around <b>${Number((privatePricings[city.state].low + privatePricings[city.state].high) / 2).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b> (Low: ${Number(privatePricings[city.state].low).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}. High: ${Number(privatePricings[city.state].high).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}).
                      {(privatePricings[city.state].low + privatePricings[city.state].high) / 2 > 1200 === true ? ' These prices are above the national average. ' : ''}
                      This information is sourced from multiple service providers and open marketplaces.
                    </p>
                    <H5>Upsolve is free.</H5>
                    <p>
                      <Link to="/">Upsolve</Link> is a nonprofit that provides free bankruptcy assistance to low-income Americans who can't afford these costs. <a href={screenerUrl}>Use our screener</a> to see if you're a fit for our service, and even start the process today.
                    </p>
                  </section>
                  <section>
                    <CTATestimonial contentGroup={contentGroup} />
                  </section>
                </div>
                <aside className="article__sidebar">
                  <div className="sidebar-hero__cta">
                    <HeroFilerCta contentGroup={contentGroup} />
                  </div>
                </aside>
              </div>
            </article>
          </div>
          <div className="related-content">
            <ContentShareRow text={title} slug={path} />
          </div>
        </Article>
        <CTASideBySideOfferings contentGroup={contentGroup} ctaText={cta} />
        <MainFooter />
      </TopLevelLayout>
    );
  }
}